import {
  GET_LEGAL,
  GET_LEGAL_SUCCESS,
  GET_LEGAL_FAIL,
  DELETE_LEGAL,
  DELETE_LEGAL_SUCCESS,
  DELETE_LEGAL_FAIL,
  UPDATE_LEGAL,
  UPDATE_LEGAL_SUCCESS,
  UPDATE_LEGAL_FAIL,
  ADD_NEW_LEGAL,
  ADD_LEGAL_SUCCESS,
  ADD_LEGAL_FAIL,
  LEGAL_LOADING,
  LEGAL_RESET,
} from "./actionType";

export const resetLegalState = (actionType) => ({
  type: LEGAL_RESET,
  payload: { actionType },
});

export const getLegalSuccess = (actionType, data) => ({
  type: GET_LEGAL_SUCCESS,
  payload: { actionType, data },
});

export const getLegalFail = (actionType, error) => ({
  type: GET_LEGAL_FAIL,
  payload: { actionType, error },
});

export const getLegal = data => ({
  type: GET_LEGAL,
  payload: data,
});

export const getLegalLoading = () => ({
  type: LEGAL_LOADING
});

export const deleteLegal = data => ({
  type: DELETE_LEGAL,
  payload: data,
});

export const deleteLegalSuccess = data => ({
  type: DELETE_LEGAL_SUCCESS,
  payload: data,
});

export const deleteLegalFail = error => ({
  type: DELETE_LEGAL_FAIL,
  payload: error,
});

export const updateLegal = data => ({
  type: UPDATE_LEGAL,
  payload: data,
});

export const updateLegalFail = error => ({
  type: UPDATE_LEGAL_FAIL,
  payload: error,
});

export const updateLegalSuccess = data => ({
  type: UPDATE_LEGAL_SUCCESS,
  payload: data,
});

export const addNewLegal = data => ({
  type: ADD_NEW_LEGAL,
  payload: data,
});

export const addLegalSuccess = data => ({
  type: ADD_LEGAL_SUCCESS,
  payload: data,
});

export const addLegalFail = error => ({
  type: ADD_LEGAL_FAIL,
  payload: error,
});